<template>
  <el-form-item :label="`${labelText}`" :label-width="labelWidth">
    <div class="flexc-cen-x">
      <el-slider
        :style="{ width: sliderWidth }"
        v-model="customerPaperwork[sliderKey]"
        :step="1"
        :min="0"
        :max="100"
      ></el-slider>
      <el-input
        @input="
          customerPaperwork[sliderKey] = +getNumberData(1, $event, 0, 0, 100)
        "
        :style="{ width: sliderInputWidth }"
        v-model="customerPaperwork[sliderKey]"
        class="ml16"
      ></el-input
      ><span class="ml8">%</span>
    </div>
  </el-form-item>
</template>
<script>
export default {
  props: {
    labelText: {
      type: String,
      default: "",
    },
    sliderKey: {
      type: String,
      default: "",
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    sliderWidth: {
      type: String,
      default: "200px",
    },
    sliderInputWidth: {
      type: String,
      default: "70px",
    },
    labelWidth: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.ml16 {
  margin-left: 16px;
}
.ml8 {
  margin-left: 8px;
}
</style>
